export const buttonColorOptions = ["yellow", "white", "black", "blue"];

export const buttonColorDefault = "yellow";
